"use client"

import styled from "@emotion/styled"
import React from "react"

const VideoWrapper = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`

interface HeroVideoProps {
  src?: string
  poster?: string
  className?: string
}

const HeroVideo: React.FC<HeroVideoProps> = ({
  src = "/videos/134635_ah_1920x1080.webm",
  poster = "/videos/c815727460cbdc1ccdd87a9856778d3973be547e.png",
  className,
}) => {
  return (
    <VideoWrapper className={className}>
      <video
        src={src}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster={poster}
        style={{ objectFit: "cover", objectPosition: "center right" }}
      />
    </VideoWrapper>
  )
}

export default HeroVideo
